<template>
  <div
    id="productWrapper"
    class="products"
  >
    <div
      v-for="product in paginatedProducts"
      :key="product.id"
      :class="[
        'products-item-' + product.id,
        { 'products-item--86d': !isKioskMode && isProduct86d(product.id) }
      ]"
      :style="{ background: transformColor[product.color.toLowerCase()] ? transformColor[product.color.toLowerCase()] : product.color}"
      class="products-item"
      @pointerdown="$emit('product-press-start', product, $event)"
      @pointerup="$emit('product-press-end')"
      @pointerleave="$emit('product-press-end')"
      @pointercancel="$emit('product-press-end')"
      @click="$emit('product-tile-click', product)"
    >
      <b-button
        :class="{ 'd-none': !isKioskMode || !product.image || !product.description }"
        class="products-info"
        variant="link"
        @click.stop.prevent="$emit('show-product-info', product)"
      />

      <lazy-image
        v-if="product.image"
        :src="product.image"
        :alt="product.name"
        class="img-responsive"
      />
      <div
        v-if="product.image"
        class="category-overlay"
      />

      <span class="products-name">
        {{ getProductDisplayName(product) }}
      </span>
      <div class="product-price">
        {{ currency }} {{ product.price.toFixed(2) }}
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from "@/components/Common/LazyImage.vue";

export default {
  name: "ProductGrid",
  components: {
    LazyImage,
  },
  props: {
    // Already-paginated product tiles for the active category (owned by parent).
    paginatedProducts: {
      type: Array,
      default: () => [],
    },
    transformColor: {
      type: Object,
      default: () => ({}),
    },
    currency: {
      type: String,
      default: "",
    },
    isKioskMode: {
      type: Boolean,
      default: false,
    },
    // Parent-bound reactive selectors/helpers (registered on this child's render
    // watcher when invoked, so 86 toggles / terminal-setting changes re-render).
    isProduct86d: {
      type: Function,
      default: () => false,
    },
    getProductDisplayName: {
      type: Function,
      default: (product) => (product ? product.name : ""),
    },
  },
};
</script>
